<template>
  <ul class="m-menu__nav m-menu__nav--submenu-arrow">
    <li
      class="m-menu__item m-menu__item--submenu m-menu__item--rel"
      data-menu-submenu-toggle="click"
      data-redirect="true"
      aria-haspopup="true"
    >
      <a href="#" class="m-menu__link m-menu__toggle">
        <span class="m-menu__link-text">Products</span>
      </a>
      <div
        class="m-menu__submenu m-menu__submenu--fixed m-menu__submenu--left"
        style="width:200px;"
      >
        <span class="m-menu__arrow m-menu__arrow--adjust"></span>
        <ul class="m-menu__subnav">
          <li class="m-menu__item m-menu__item--active" aria-haspopup="true">
            <a href="https://getcarbon.co/payments/" class="m-menu__link">
              <span class="m-menu__link-text">Payments</span>
            </a>
          </li>
          <li class="m-menu__item m-menu__item--active" aria-haspopup="true">
            <a href="https://getcarbon.co/loans/" class="m-menu__link">
              <span class="m-menu__link-text">Loans</span>
            </a>
          </li>

          <li class="m-menu__item m-menu__item--active" aria-haspopup="true">
            <a href="https://getcarbon.co/investments/" class="m-menu__link">
              <span class="m-menu__link-text">Investments</span>
            </a>
          </li>
          <li class="m-menu__item m-menu__item--active" aria-haspopup="true">
            <a href="https://getcarbon.co/bloom/" class="m-menu__link">
              <span class="m-menu__link-text">Bloom</span>
            </a>
          </li>
        </ul>
      </div>
    </li>
    <li class="m-menu__item">
      <a href="https://blog.getcarbon.co/" class="m-menu__link">
        <span class="m-menu__link-text">Blog</span>
      </a>
    </li>
    <li class="m-menu__item">
      <a href="https://getcarbon.co/faqs/" class="m-menu__link">
        <span class="m-menu__link-text">FAQs</span>
      </a>
    </li>
    <li class="m-menu__item">
      <a href="https://getcarbon.co/ourstory/" class="m-menu__link">
        <span class="m-menu__link-text">Our Story</span>
      </a>
    </li>
<!--    <li class="m-menu__item">-->
<!--      <router-link v-on:click.native="clickOnItem()" :to="{ name: 'fcr-register' }" class="m-menu__link">-->
<!--        <span class="m-menu__link-text">-->
<!--          <span :class="getActiveClass('fcr-register')">Free Credit Report</span>-->
<!--        </span>-->
<!--      </router-link>-->
<!--    </li>-->
    <li class="m-menu__item">
      <router-link v-on:click.native="clickOnItem()" :to="{ name: 'complaint' }" class="m-menu__link">
        <span class="m-menu__link-text">
          <span>Complaints</span>
        </span>
      </router-link>
    </li>
    <li class="m-menu__item">
      <router-link v-on:click.native="clickOnItem()" :to="{ name: 'login' }" class="m-menu__link">
        <span class="m-menu__link-text">
          <span :class="getActiveClass('login')">Sign In</span>
        </span>
      </router-link>
    </li>
<!--    <li class="m-menu__item">-->
<!--      <router-link v-on:click.native="clickOnItem()" :to="{ name: 'register' }" class="m-menu__link">-->
<!--        <span class="m-menu__link-text">-->
<!--          <span :class="getActiveClass('register')">GetCarbon</span>-->
<!--        </span>-->
<!--      </router-link>-->
<!--    </li>-->
  </ul>
</template>
<script>
export default {
  methods: {
    clickOnItem() {
      if (window.innerWidth < 993) {
        $("body").removeClass("m-aside-header-menu-mobile--on");
        $("#m_header_menu").removeClass("m-aside-header-menu-mobile--on");
      }
    },
    getActiveClass(input) {
      return this.$route.name == input
        ? "m-menu__link-button"
        : "m-menu__link-text";
    }
  }
};
</script>
